<template>
  <div>
    <el-table :data="tableData"
              style="width: 100%;margin-bottom: 20px;"
              border
              row-key="parameter"
              :header-cell-style="{ color: '#1572e9' }"
              :row-class-name="tableRowClassName"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column type="index"
                       width="50" />
      <el-table-column prop="parameter"
                       label="参数"
                       width="340">
        <template slot-scope="scope">
          <del v-if="scope.row.del">{{scope.row.parameter}} <span style="color:red;"> *弃用</span></del>
          <span v-else-if="scope.row.add">{{scope.row.parameter}} <span style="color:#3fd64c;"> *新增</span></span>
          <span v-else>{{scope.row.parameter}} </span>
        </template>
      </el-table-column>
      <el-table-column prop="type"
                       label="类型"
                       width="280">
      </el-table-column>
      <el-table-column prop="data"
                       label="详情及说明">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      tableData: [{
        parameter: 'height',
        type: 'String( 官网无默认值，框架默认 auto )',
        data: '表格的高度，默认为自动高度。如果设置为auto，会自适应窗口高度，'
      },
      {
        parameter: 'menu',
        type: 'Boolean( 默认 true )',
        data: '是否有操作栏'
      },
      {
        parameter: 'menuWidth',
        type: 'Number( 默认 220 )',
        data: '操作栏宽度'
      },
      {
        parameter: 'menuFixed',
        type: 'Boolean( 默认 true )',
        data: '操作栏列冻结列'
      },
      {
        parameter: 'selection',
        type: 'Boolean( 默认 false )',
        data: '表格是否有选择框'
      },
      {
        parameter: 'dialogDrag',
        type: 'Boolean( 框架默认 true )',
        data: '对话框是否可以拖拽'
      },
      {
        parameter: 'dialogWidth',
        type: 'String(默认 60%)',
        data: '对话框宽度'
      },
      {
        parameter: 'addBtn / editBtn / delBtn / viewBtn',
        type: 'Boolean(将会根据框架权限显示隐藏)',
        data: '新增/修改/删除/详情 按钮是否显示， '
      },
      {
        parameter: 'searchLabelWidth',
        type: 'Number(官网默认 80 框架处理为 110)',
        data: '搜索项标题宽度 ， 单位为px '
      },
      {
        parameter: 'calcHeight',
        type: 'Number(框架处理为 30)',
        data: ' 表格高度差（主要用于减去其他部分让表格高度自适应） '
      },
      {
        parameter: 'index',
        type: 'Boolean( 默认 true )',
        data: '是否显示序号'
      },
      {
        parameter: 'indexLabel',
        type: 'String(框架处理为 序号)',
        data: '索引列的文字 默认为#'
      },
      {
        parameter: 'closeToolbar(自定义扩展)',
        type: 'Boolean',
        data: '为true 关闭操作列显隐持久化功能 ,需混入crudmixins.js',
        custom: true
      },
      {
        parameter: 'theRight(自定义扩展) 2022/11/29',
        type: 'Boolean',
        data: '为true 关闭查询重置自动居右功能， 需混入crudmixins.js',
        custom: true,
        del: true,
      },
      {
        parameter: 'cancelHijack(自定义扩展)',
        type: 'Boolean',
        data: '为true 关闭重构的表格适配方案， 需混入crudmixins.js',
        custom: true
      },
      {
        parameter: 'GridSize(自定义扩展) 2022/11/29',
        type: 'Number (3)',
        data: '查询适配列数需要参照的适配数值， 需混入crudmixins.js',
        custom: true,
        del: true,
      },
      {
        parameter: 'cancelDefault(自定义扩展)',
        type: 'Boolean',
        data: '为true关闭  新增时单位只有一个时默认选中， 需混入crudmixins.js',
        custom: true
      },
      {
        parameter: 'cancelDefault(自定义扩展)',
        type: 'Boolean',
        data: '为true关闭  查询时单位只有一个时默认选中， 需混入crudmixins.js',
        custom: true
      },
      {
        parameter: 'searchDateProp(自定义扩展)',
        type: '(Boolean || String || Object)',
        data: '*====*一.为false关闭默认查询处理。*====* 二.为 String 传入字段会被当做 时间集类型 查询条件处理。*====*三.为Object时 1.{ startTime:"xx", endTime:"xx", type:"month"} 传入开始或结束时间 将被处理为 时间组类型。2.{ startTime:"xx", type:"month"}仅有一个startTime时 仍会被处理为时间集类型。四.Object 中 type为默认的范围 目前支持 月 周 日。 详见本页面查询日期组件使用说明',
        custom: true
      },
      {
        parameter: 'closeSearchAuto(自定义扩展) 2022/11/29',
        type: 'Boolean',
        data: '为true关闭  根据查询列数排列按钮， 需混入crudmixins.js',
        custom: true,
        add: true
      },
      {
        parameter: 'column',
        type: 'Array',
        data: '表格表单的基本配置项',
        children: [{
          parameter: 'label',
          type: 'String',
          data: '字段标题名'
        },
        {
          parameter: 'prop',
          type: 'String',
          data: '字段key名'
        }
          ,
        {
          parameter: 'type',
          type: 'String( 默认input )',
          data: '字段需要使用的类型 支持（input/select/Number/tree/remark）'
        }
          ,
        {
          parameter: 'dataType',
          type: 'String( 除特殊处理外不用写 如:tree,date)',
          data: '数据值的类型'
        }
          ,
        {
          parameter: 'hide',
          type: 'Boolean',
          data: '列表中是否被隐藏'
        }
          ,
        {
          parameter: 'search',
          type: 'Boolean( 默认 false )',
          data: '是否为搜索项'
        },
        {
          parameter: 'searchValue',
          type: '-',
          data: '搜索的默认值'
        }
          ,
        {
          parameter: 'searchPlaceholder',
          type: 'String(框架已处理默认值)',
          data: '搜索的Placeholder提示内容'
        }
          ,
        {
          parameter: 'searchSpan',
          type: 'String(框架已处理为 8)',
          data: '搜索项框栅列，栅格平均分为24份 框架统一处理 不建议修改'
        }
          ,
        {
          parameter: 'span',
          type: 'String(框架已处理为 8)',
          data: '表单项框栅列，栅格平均分为24份 框架统一处理 不建议修改'
        }
          ,
        {
          parameter: 'showColumn',
          type: 'Boolean( 默认 true )',
          data: '是否在操作列显隐中可编辑'
        }
          ,
        {
          parameter: 'searchOrder',
          type: 'Number',
          data: '	搜索项位置排序，序号越大越靠前'
        }
          ,
        {
          parameter: 'width',
          type: 'String',
          data: '对应列的宽度'
        }
          ,
        {
          parameter: 'addDisplay / editDisplay / viewDisplay',
          type: 'Boolean( 全部默认 true )',
          data: '字段在：新增/修改/详情 中是否显示'
        }
          ,
        {
          parameter: 'addDisabled / editDisabled / viewDisabled',
          type: 'Boolean( 全部默认 false )',
          data: '字段在：新增/修改/详情 中是否为禁用状态， 全部禁用 设置disabled为true'
        }
          ,
        {
          parameter: 'overHidden',
          type: 'Boolean( 默认 false )',
          data: '当内容过长被隐藏时显示 tooltip 在列表中生效'
        }
          ,
        {
          parameter: 'dicUrl',
          type: 'String',
          data: '数据字典接口url地址'
        }
          ,
        {
          parameter: 'props',
          type: 'object',
          data: '数据字典属性的配置对象, '
        }
          ,
        {
          parameter: 'rules',
          type: 'Array',
          data: '字段在表单内的验证规则 '
        }
          ,
        {
          parameter: 'remote',
          type: 'Boolean( 默认 false )',
          data: '是否开启远程搜索，常用于拼音码'
        }
          ,
        {
          parameter: 'checkStrictly ',
          type: 'Boolean( 默认 false )',
          data: '来设置父子节点取消选中关联，从而达到选择任意一级选项的目的。'
        }
          ,
        {
          parameter: 'searchMultiple',
          type: 'Boolean( 默认 false )',
          data: '搜索项是否多选。'
        }
          ,
        {
          parameter: 'defaultExpandAll',
          type: 'Boolean( 默认 false )',
          data: '是否默认展开所有行，当前表格包含展开行存在或者为树形表格时有效'
        }
          ,
        {
          parameter: 'resizable',
          type: 'Boolean( 默认 false )',
          data: '对应的列是否可以拖拽'
        }
          ,
        {
          parameter: 'showWordLimit',
          type: 'Boolean( 默认 false )',
          data: '属性来展示字数统计'
        }
          ,
        {
          parameter: 'minRows',
          type: 'Number',
          data: 'remark类型输入框 最小行数'
        }
          ,
        {
          parameter: 'formatter',
          type: 'Function',
          data: '方法格式化内容',
        },
        {
          parameter: 'numFormat(自定义扩展)',
          type: 'Boolean',
          data: '统一修改千位分隔符  需要搭配numSeparator方法使用，具体见示例功能。不想使用可 改用formatter自己实现',
          custom: true
        },
        ]
      }],
    }
  },


  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.custom) {
        return 'custom'
      }
      if (rowIndex % 2 === 0 && row.data != '表格表单的基本配置项') {
        return 'success-row'
      } else if (row.data == '表格表单的基本配置项') {
        return 'overstriking'
      }
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .success-row {
  background-color: #eaf3fb !important;
}
::v-deep .overstriking {
  .cell {
    font-weight: 900 !important;
    color: #000;
  }
}

::v-deep .custom {
  .cell {
    font-weight: 600 !important;
    color: rgb(75, 135, 224);
  }
}
</style>